import { Box } from '@chakra-ui/react';
import dynamic from 'next/dynamic';

export const CSRContent = dynamic(() => import('./Content').then(({ Content }) => Content), {
  ssr: false,
  loading: () => (<Box data-testid="csr-loading"></Box>),
});
